import { useStatsigClient } from '@statsig/react-bindings'
import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

const excludePaths = [
  '/credit-cards/best/',
  '/credit-cards/best/balance-transfer/',
  '/credit-cards/best/low-interest/',
]

export const useEnhanceCompareCardsVisibility = () => {
  const statsigClient = useStatsigClient()
  const pathname = usePathname()

  const shouldEnhanceCompareCardsVisibility = useMemo(() => {
    const isValidPath =
      !excludePaths.includes(pathname) &&
      !pathname.includes('/credit-cards/tips')
    return isValidPath
      ? statsigClient
          .getExperiment('exp_148_enhance_compare_cards_visibility')
          .get('show_enhanced_compare_cards', false)
      : false
  }, [statsigClient, pathname])

  return shouldEnhanceCompareCardsVisibility
}
